import { useDispatch, useSelector } from "react-redux";
import {
  ERROR_STRING
  // VALIDATION_ERROR
} from "../../../app/errors";
import {
  APPLICATION_MODE_NEW,
  APPLICATION_STATUS_APPROVED_ISSUED,
  APPLICATION_STATUS_UNREAD,
  DOCUMENT_CONTENT_TYPE_PDF,
  DOCUMENT_TYPE_CRIMINAL_RECORD,
  DOCUMENT_TYPE_INSURANCE_CONTINURATION,
  individualFileSizeAllowedInMB,
  LICENCE_STATUS_ACTIVE,
  REQUEST_STATUS
} from "../../../app/constants";
import {
  acceptedFileFormats,
  convertFileDataForUrl,
  // convertFileDataForUrl,
  extractBase64,
  fileNameWithLengthLimit,
  fileSizeReplacement,
  fileTypeEnum,
  getDocumentsMapForApplication,
  getDocumentTypeName,
  validateFileName
} from "../../../app/documentUploadUtils";
import { useEffect, useMemo, useState } from "react";
import {
  Button,
  // ErrorMark,
  Header,
  MainSeparator,
  NavigationLinkButton
} from "../../../components/RegularComponents";
import {
  DocumentViewerFileNameLink,
  DownloadFileNameLink
} from "../../../components/DocumentViewer/DocumentFileComponent";
import { fetchDocumentData } from "../../../redux/slice/supportingDocumentsSlice";
import fileUploadSelect from "../../../redux/selector/fileUploadSelector";
import {
  addAgentDocumentsToUpload,
  setCurrentAgentApplicationId,
  setCurrentAgentApplicationStatus,
  setCurrentAgentMortgageProperty
} from "../../../redux/slice/additionalApplicationsSlice";
import {
  addAgencyDocumentsToUpload,
  setAgencyApplicationStatus,
  setMortgageProperty
} from "../../../redux/slice/primaryAgencyApplicationSlice";
import { saveBusinessLicenceApplicationData } from "../../../redux/slice/businessLicenceApplicationSlice";
import {
  applicationTypeFromLicenceSubType,
  isAgencyTypeApplication,
  isIndividualTypeApplication,
  isNonCollectionOrDebtAgencyApplication
} from "../../../redux/slice/applicationsUtils";
import { fetchApplicationWithIdAndSetStore } from "../../../redux/slice/collectionApplicationSlice";
import TopNavigationBar from "../../TopNavigationBar";
import { fullName, humanReadableDate } from "../../../app/utils";
import DocumentViewer from "../../../components/DocumentViewer/DocumentViewer";

const SELECT_DEFAULT = "default";

const FileUploadView = (props) => {
  const dispatch = useDispatch();

  // const [documetValidationError, setDocumetValidationError] = useState();
  const [selectedApplication, setSelectedApplication] = useState(null);
  //For quick dropdown selection display - Id is used
  const [selectedApplicationId, setSelectedApplicationId] = useState(SELECT_DEFAULT);
  const [selectedDocumentType, setSelectedDocumentType] = useState(null);
  const [showUploadSuccess, setShowUploadSuccess] = useState(false);
  // const [showValidationError, setShowValidationError] = useState(false);
  // const [applicationSaveError, setApplicationSaveError] = useState(false);
  const [documentViewerDocument, setDocumentViewerDocument] = useState(null);
  const [documentViewerFilename, setDocumentViewerFilename] = useState("");
  const [documentsToUpload, setDocumentsToUpload] = useState([]);
  const [selectedOfficer, setSelectedOfficer] = useState(null);

  const applicationsMap = useSelector(fileUploadSelect);

  const serverRequestStatus = useSelector(
    (state) => state.primaryAgencyApplication?.serverRequestStatus
  );

  useEffect(() => {
    //Choose agency default for Collection and Debt
    if (
      applicationsMap?.primaryAgencyApplication &&
      !isNonCollectionOrDebtAgencyApplication(applicationsMap?.primaryAgencyApplication)
    ) {
      setSelectedApplicationId(applicationsMap.primaryAgencyApplication.id);
      setSelectedApplication(applicationsMap.primaryAgencyApplication);
    }
  }, [applicationsMap?.primaryAgencyApplication]);

  const applicationOptionElements = useMemo(() => {
    const applicationsList = [
      <option key="select" value={SELECT_DEFAULT} disabled>
        Select an application
      </option>
    ];

    if (applicationsMap.primaryAgencyApplication) {
      applicationsList.push(
        <option
          key={applicationsMap.primaryAgencyApplication.id}
          value={applicationsMap.primaryAgencyApplication.id}
        >
          {applicationsMap.primaryAgencyApplication.name || applicationsMap.primaryAgencyApplication.contactName}
        </option>
      );
    }

    if (isNonCollectionOrDebtAgencyApplication(applicationsMap.primaryAgencyApplication)) {
      if (applicationsMap.additionalApplications?.agentApplications) {
        applicationsMap.additionalApplications.agentApplications.forEach((app) => {
          applicationsList.push(
            <option key={app.id} value={app.id}>
              {app.contactName}
            </option>
          );
        });
      }
    }

    return applicationsList;
  }, [applicationsMap]);

  const rjscOfficersOptions = useMemo(() => {
    if (
      !isAgencyTypeApplication(selectedApplication) ||
      selectedDocumentType !== DOCUMENT_TYPE_CRIMINAL_RECORD
    ) {
      return null;
    }
    const officersList = [
      <option key="select" value={SELECT_DEFAULT} disabled>
        Select an officer
      </option>
    ];

    const peopleList =
      selectedApplication.businessLicenceData?.companyRjscDetails?.businessData?.peopleList;

    peopleList?.forEach((person) => {
      const positions = person.position?.split(",") || [];
      let isMatch = false;
      for (const pos of positions) {
        if (pos.toLowerCase() === "officer") {
          isMatch = true;
        }
      }
      if (isMatch) {
        officersList.push(
          <option key={person.entityId} value={person.entityId}>
            {fullName(person) + ", " + person.position}
          </option>
        );
      }
    });
    return officersList;
  }, [selectedApplication, selectedDocumentType]);

  const existingDocuments = useMemo(() => {
    if (!selectedApplication?.documents) {
      return [];
    }

    return selectedApplication?.documents?.map((doc) => {
      return (
        <FileComponent
          key={doc.filename + doc.documentType}
          file={doc}
          withRemove={false}
          setDocumentViewerDocument={setDocumentViewerDocument}
          setDocumentViewerFilename={setDocumentViewerFilename}
        />
      );
    });
  }, [selectedApplication]);

  const documentTypesMap = getDocumentsMapForApplication(selectedApplication);

  const onDocumentTypeSelect = (documentType) => {
    setSelectedDocumentType(documentType);

    setShowUploadSuccess(false);
    setSelectedOfficer(null);
  };

  const getDocumentTypeRadios = () => {
    const documentTypeRadioList = [];
    for (const dt in documentTypesMap) {
      if (Object.prototype.hasOwnProperty.call(documentTypesMap, dt)) {
        const dtName = documentTypesMap[dt];
        documentTypeRadioList.push(
          <div
            key={dtName}
            className="ns-radios__item"
            style={{ marginBottom: "15px" }}
            onClick={() => {
              onDocumentTypeSelect(dt);
            }}
          >
            <input
              className="ns-radios__input"
              type={"radio"}
              value={dt}
              checked={selectedDocumentType === dt}
              onChange={(e) => onDocumentTypeSelect(e.target.value)}
            />
            <label className="ns-radios__label">
              <span className="ns-label-span">{dtName}</span>
            </label>
          </div>
        );
      }
    }
    return documentTypeRadioList;
  };

  const fetchLicenceApplication = async (applicationId) => {
    dispatch(fetchApplicationWithIdAndSetStore(parseInt(applicationId), false, true)).then(
      (applicationData) => {
        if (isIndividualTypeApplication(applicationData)) {
          dispatch(setCurrentAgentApplicationId(parseInt(applicationData.id)));
        } else {
          //Unset cuurent agent application id if previously set.
          dispatch(setCurrentAgentApplicationId(null));
        }
        setSelectedApplication(applicationData);
      }
    );
  };

  const onSelectChange = (e) => {
    const applicationId = parseInt(e.target.value);
    fetchLicenceApplication(applicationId);
    //For quick dropdown selection display - Id is used
    setSelectedApplicationId(applicationId);

    //Clear prev files and status -
    setDocumentsToUpload([]);
    setShowUploadSuccess(false);
    setSelectedDocumentType(null);
    setSelectedOfficer(null);
  };

  const onOfficerChange = (e) => {
    const officerId = e.target.value;
    const peopleList =
      selectedApplication.businessLicenceData?.companyRjscDetails?.businessData?.peopleList;
    const officer = peopleList?.find((o) => o.entityId === officerId);
    setSelectedOfficer(officer);
  };

  const handleFileInput = (e) => {
    if (e.target.files.length > 0) {
      const file = e.target.files[0];

      // individual file size can not be more than 15 MB
      if (file.size > individualFileSizeAllowedInMB * 2 ** 20) {
        alert(
          fileSizeReplacement(
            ERROR_STRING.SUPPORTING_DOC_VERY_LARGE_INDIVIDUAL_FILE,
            individualFileSizeAllowedInMB
          )
        );
        return;
      } else if (!validateFileName(file.name)) {
        alert("File name is not valid. Please select another file.");
        return;
      }

      const reader = new FileReader();
      reader.onload = (readerData) => {
        const docData = {
          filename: fileNameWithLengthLimit(file.name),
          documentContentType: fileTypeEnum(file.type),
          data: extractBase64(readerData.target.result),
          changeType: "SAVE",
          documentType: selectedDocumentType,
          fileSize: file.size,
          isUpdated: true
        };

        if (selectedOfficer && selectedDocumentType === DOCUMENT_TYPE_CRIMINAL_RECORD) {
          //For criminal record check
          docData.entityId = selectedOfficer.entityId;
        }

        setDocumentsToUpload([...documentsToUpload, docData]);
      };
      reader.readAsDataURL(file);

      setShowUploadSuccess(false);
    }
  };

  const handleRemoveDocument = (file) => {
    setDocumentsToUpload(documentsToUpload?.filter((doc) => doc !== file));
  };

  const handleUploadDocuments = () => {
    let applicationType;
    if (applicationsMap.primaryAgencyApplication.id === selectedApplicationId) {
      //Agency
      dispatch(addAgencyDocumentsToUpload({ documents: documentsToUpload }));
      dispatch(setMortgageProperty({ key: "isDocumentUpdated", value: true }));

      dispatch(setAgencyApplicationStatus(APPLICATION_STATUS_UNREAD));

      applicationType = applicationTypeFromLicenceSubType(
        applicationsMap.primaryAgencyApplication.licencingSubType
      );
    } else if (applicationsMap.additionalApplications?.agentApplications?.length) {
      const agentApplications = applicationsMap.additionalApplications.agentApplications;
      const searchedApplication = agentApplications.find((app) => app.id === selectedApplicationId);

      if (searchedApplication) {
        //Agent
        dispatch(
          addAgentDocumentsToUpload({
            agentApplicationId: searchedApplication.id,
            documents: documentsToUpload
          })
        );

        dispatch(
          setCurrentAgentMortgageProperty({
            key: "isDocumentUpdated",
            value: true
          })
        );

        if (
          searchedApplication.applicationStatus !== APPLICATION_STATUS_APPROVED_ISSUED &&
          searchedApplication.licenceStatus === LICENCE_STATUS_ACTIVE
        ) {
          //Note only If the application is active, reset old review-data
          dispatch(
            setCurrentAgentMortgageProperty({
              key: "reviewDataCollectionDebt",
              value: null
            })
          );
        }

        dispatch(setCurrentAgentApplicationStatus(APPLICATION_STATUS_UNREAD));
        applicationType = applicationTypeFromLicenceSubType(searchedApplication.licencingSubType);
      }
    }

    dispatch(saveBusinessLicenceApplicationData(applicationType, APPLICATION_MODE_NEW))
      .then(() => {
        console.log("Upload success");
        setShowUploadSuccess(true);
        //Return to the home screen
        navigateBack();
      })
      .catch((e) => {
        alert("Unable to save the documents.");
        console.log("Upload error", e);
      });
  };

  const navigateBack = () => {
    props.history.goBack();
  };

  return (
    <div className="container">
      <TopNavigationBar {...props} />
      <Header style={{ paddingBottom: "20px" }} header="Upload File" />
      <div>
        <label className="ns-label">Select an application to upload the documents: </label>
        <div className="select fw-25 inlineDisplay">
          <select
            className={false ? "select--error" : ""}
            style={{ width: "25em" }}
            id={"application-select-input"}
            name={"application-select-input"}
            value={selectedApplicationId}
            onChange={onSelectChange}
          >
            {applicationOptionElements}
          </select>
        </div>
        {documentTypesMap ? (
          <div>
            <fieldset className={"ns-fieldset"}>
              <div className={"ns-radios ns-radios--small"}>{getDocumentTypeRadios()}</div>
            </fieldset>
          </div>
        ) : null}
      </div>

      {rjscOfficersOptions ? (
        <div className="row">
          <div className={"col-lg-8"}>
            <label>Select the officer for whom the Criminal Record Check is getting updated</label>
            <div className="select fw-25 inlineDisplay">
              <select
                className={false ? "select--error" : ""}
                style={{ width: "25em" }}
                id={"application-select-input"}
                name={"application-select-input"}
                value={selectedOfficer?.entityId || SELECT_DEFAULT}
                onChange={onOfficerChange}
              >
                {rjscOfficersOptions}
              </select>
            </div>
          </div>
        </div>
      ) : null}

      <div className="row" style={{ marginTop: 30 }}>
        <div className="col-xs-12 col-lg-8">
          <div className={"ns-fieldset"}>
            <fieldset className="ns-fieldset" id="criminal-records-form">
              <div className={"ns-fieldset"}>
                <label className="ns-label" id="upload-file-label" htmlFor="upload-file-input">
                  Upload a file
                </label>
                <div className="ns-file-input">
                  <input
                    disabled={!selectedDocumentType}
                    className="ns-input"
                    style={{ width: "15em", display: "inline" }}
                    type="file"
                    value=""
                    accept={acceptedFileFormats(DOCUMENT_TYPE_INSURANCE_CONTINURATION).join(",")}
                    id="upload-file-input"
                    name="upload-file-input"
                    multiple={false}
                    onInput={handleFileInput}
                  />
                </div>
              </div>
            </fieldset>
            {/*documetValidationError !== VALIDATION_ERROR.NO_ERROR && (
              <span
                id={"available-document--error"}
                className="ns-error-message field-validation-document-error"
              >
                {"Please upload a valid file."}
              </span>
            )*/}
          </div>
        </div>
      </div>
      {documentsToUpload?.length ? (
        <div className="row">
          <div className="col-xs-12 col-lg-8">
            <label>Selected documents to upload:</label>
            <table>
              <thead>
                <tr>
                  <th>{"File Type"}</th>
                  <th>{"File Name"}</th>
                  <th>{"Type"}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {documentsToUpload?.map((doc) => {
                  return (
                    <FileComponent
                      key={doc.filename + doc.documentType}
                      file={doc}
                      withRemove={true}
                      handleRemoveDocument={handleRemoveDocument}
                      setDocumentViewerDocument={setDocumentViewerDocument}
                      setDocumentViewerFilename={setDocumentViewerFilename}
                    />
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      ) : null}

      <div className="row">
        <div className={"col-lg-4"}>
          <Button
            className="btn-lg btn-default"
            style={{ margin: "0 10px 10px 0" }}
            buttonType={"regular_primary"}
            text={"Upload and Return to Dashboard"}
            onClick={handleUploadDocuments}
            showSpinner={serverRequestStatus === REQUEST_STATUS.IN_PROGRESS}
            disabled={
              serverRequestStatus === REQUEST_STATUS.IN_PROGRESS || !documentsToUpload?.length
            }
          />
          {/*
          {(applicationSaveError || showValidationError) && ErrorMark()}
          {applicationSaveError && (
            <div className="ns-error-message help-block topMarginNormal">
              <span className="ns-visually-hidden">Error:</span>
              {ERROR_STRING.APPLICATION_SAVE_ERROR}
            </div>
          )}
          {showValidationError && (
            <div className="ns-error-message help-block topMarginNormal">
              <span className="ns-visually-hidden">Error:</span>
              {ERROR_STRING.CHECK_FIELDS}
            </div>
          )}
          */}
        </div>
        <div className="col-lg-4">
          <NavigationLinkButton
            id="file-upload-cancel-button"
            text="Cancel"
            onClick={navigateBack}
          />
        </div>
      </div>
      {showUploadSuccess ? <div>Documents uploaded sucessfully</div> : null}
      {existingDocuments?.length ? (
        <div style={{ marginTop: 40 }}>
          <MainSeparator />
          <div className="row">
            <div className="col-xs-12 col-lg-8">
              <label>
                Uploaded documents for :{" "}
                {isAgencyTypeApplication(selectedApplication)
                  ? selectedApplication.name
                  : selectedApplication.contactName}
              </label>
              <table>
                <thead>
                  <tr>
                    <th>{"File Type"}</th>
                    <th>{"File Name"}</th>
                    <th>{"Type"}</th>
                    <th>{"Created Date"}</th>
                  </tr>
                </thead>
                <tbody>{existingDocuments}</tbody>
              </table>
            </div>
          </div>
        </div>
      ) : null}
      <DocumentViewer
        fileData={documentViewerDocument}
        fileName={documentViewerFilename}
        isOpen={!!documentViewerDocument}
        handleClose={() => {
          setDocumentViewerDocument(null);
          setDocumentViewerFilename("");
        }}
      />
    </div>
  );
};

const FileComponent = (props) => {
  const dispatch = useDispatch();
  const file = props.file;
  return (
    <tr>
      <td>{getDocumentTypeName(file.documentType)}</td>
      <td className="fileName">
        {file.id && file.documentContentType === DOCUMENT_CONTENT_TYPE_PDF ? (
          <DocumentViewerFileNameLink
            id={"Filetype" + file.filename}
            file={file}
            onClick={() => {
              if (file.data) {
                const fileDataUrl = convertFileDataForUrl(file.data, file.documentContentType);
                if (props.setDocumentViewerDocument) {
                  props.setDocumentViewerDocument(fileDataUrl);
                  props.setDocumentViewerFilename(file.filename);
                }
              } else {
                // download data and then view it.
                if (file.guid) {
                  dispatch(fetchDocumentData(file.guid))
                    .then((downloadFile) => {
                      if (downloadFile) {
                        const fileDataURL = convertFileDataForUrl(
                          downloadFile.data,
                          downloadFile.documentContentType
                        );
                        if (props.setDocumentViewerDocument) {
                          props.setDocumentViewerDocument(fileDataURL);
                          props.setDocumentViewerFilename(file.filename);
                        }
                      }
                    })
                    .catch((error) => {
                      console.error(error);
                      alert("Unable to fetch the document.");
                    });
                }
              }
            }}
          />
        ) : (
          <DownloadFileNameLink
            id={"upload-file-" + file.filename}
            componentKey={"upload-file-" + file.filename}
            file={file}
          />
        )}
      </td>
      <td>{file.documentContentType}</td>
      <td>
        {props.withRemove ? (
          <NavigationLinkButton
            id={"upload-file-remove-link"}
            text={"- Remove this file"}
            onClick={() => {
              if (Object.keys(file).length > 0 && props.handleRemoveDocument) {
                props.handleRemoveDocument(file);
              }
            }}
          />
        ) : (
          humanReadableDate(file.createdDate)
        )}
      </td>
    </tr>
  );
};

export default FileUploadView;
